// Placeholder module. The `private-next-instrumentation-client` webpack alias
// resolves to this file so the resolver has a real path to find; its contents
// are then replaced by `next-instrumentation-client-loader` via a `module.rules`
// entry in webpack-config.ts.
module.exports = {}
